import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'social-impact-bx',
  footer: 'about',
}

const pageBrand: PageBrand = 'corporate'

export const holidayDelighter = new LineOfBusinessConfig(geConfig, pageBrand)
